// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled[data-v-125ed05e] { background-color: #ccc4c4 !important; color: black;\n}\n.normal[data-v-125ed05e] { background-color: #73963c !important; color: black;\n}\n.demo[data-v-125ed05e] { background-color: steelblue !important; color: black;\n}\n.userkiosk[data-v-125ed05e] { background-color: #ff3f3f !important; color: black;\n}\n.quotaWarning[data-v-125ed05e] { color: red\n}\n", ""]);
// Exports
module.exports = exports;
